<div *ngFor="let alert of alerts" 
class="{{cssClass(alert)}} fixed top-0 z-50 flex text-center w-1/2 border-2 rounded-md px-3 py-3">
    <div class="message-div"><span [innerHTML]="alert.message"></span></div>
    <div class="flex-1"><a class="float-right cursor-pointer" (click)="removeAlert(alert)">&times;</a></div>
</div>  

